import { Component, ViewEncapsulation, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tidy-bar',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./bar.component.scss'],
  template: `
    <mat-progress-bar *ngIf="value > 0" mode="determinate"  [value]="value" [ngClass]="color"></mat-progress-bar>
    <div *ngIf="value === 0">-</div>
  `
})

export  class BarComponent implements OnInit {


  @Input() disableColor: boolean;
  @Input() value = 1;
  color: string;

  ngOnInit() {
    if (!this.disableColor) {
      this.color = this.getColor(this.value);
    }
  }

  getColor(value: number): string {
    if (value > rangeValues.MEDIUM) {
      return 'tidy-green';
    } else if (value > rangeValues.LOW) {
      return 'orange';
    } else {
      return 'red';
    }
  }
}

export const rangeValues = {
  LOW: 33,
  MEDIUM: 66,
  HIGH: 100
};
